<div
  class="card h-100 w-100 flex-grow-1 shadow-sm border-0 generic-card"
  [class.generic-card-clickable]="isClickable"
  [attr.tabindex]="isClickable ? 0 : null"
  [attr.aria-label]="isClickable ? 'Apri dettaglio di ' + title : null"
  (click)="onCardClick($event)"
  (keydown)="onCardKeydown($event)"
>
  @if (showHeader) {
    <div class="card-header generic-card-header py-3">
      <div class="d-flex justify-content-between align-items-start gap-2">
        <div class="d-flex flex-column gap-1 flex-grow-1">
          <h3 class="h5 mb-0 fw-bold">{{ title }}</h3>
          <ng-content select="[card-header-extra]"></ng-content>
        </div>
        @if (canEdit) {
          <a class="btn btn-warning btn-sm flex-shrink-0" [title]="editLabel" [attr.aria-label]="editAriaLabel"
             [routerLink]="editLink ?? detailLink" (click)="$event.stopPropagation()">
            <i class="bi bi-pencil-fill" aria-hidden="true"></i>
          </a>
        }
      </div>
    </div>
  }

  <div
    class="card-body d-flex flex-column"
    [class.pt-2]="showHeader && !showTitle && !showDescription"
  >
    @if (showTitle || showDescription || (canEdit && !showHeader)) {
      <div class="mb-2">
        @if (showTitle) {
          <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
            <p class="fw-bold fs-5 mb-0 generic-card-title">{{ title }}</p>
            @if (canEdit && !showHeader) {
              <a class="btn btn-warning btn-sm flex-shrink-0" [title]="editLabel" [attr.aria-label]="editAriaLabel"
                 [routerLink]="editLink ?? detailLink" (click)="$event.stopPropagation()">
                <i class="bi bi-pencil-fill" aria-hidden="true"></i>
              </a>
            }
          </div>
        } @else if (canEdit && !showHeader) {
          <div class="d-flex justify-content-end mb-1">
            <a class="btn btn-warning btn-sm" [title]="editLabel" [attr.aria-label]="editAriaLabel"
               [routerLink]="editLink ?? detailLink" (click)="$event.stopPropagation()">
              <i class="bi bi-pencil-fill" aria-hidden="true"></i>
            </a>
          </div>
        }
        @if (showDescription) {
          <div
            #descriptionEl
            class="mb-0 small generic-card-description"
            [class.generic-card-description--clamp]="clampDescription"
            [class.generic-card-description--interactive]="isDescriptionClamped()"
            [innerHTML]="sanitizedDescription"
            (click)="onDescriptionClick($event)"
          ></div>
        }
      </div>
    }

    <div class="card-text flex-grow-1" [class.mb-4]="showTitle || showDescription"
         [class.mb-2]="!showTitle && !showDescription">
      <div class="d-flex flex-column gap-2">
        <ng-content select="[card-content]"></ng-content>
      </div>
    </div>

    <div
      class="d-grid gap-2 d-sm-flex justify-content-sm-start generic-card-actions"
    >
      <ng-content select="[card-actions]"></ng-content>
    </div>

    @if (showFooter) {
      <div class="card-footer generic-card-footer border-top-0">
        <div class="row g-2">
          <ng-content select="[card-footer]"></ng-content>
        </div>
      </div>
    }
  </div>
</div>
